import React from "react";
import {Workflow} from "common/flowmaster/types/workflow";
import ConfirmDialog from "common_components/confirm_dialog";

type DataAssetLockConfirmDialogProps = {
  dataAsset: Workflow;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

type UnlockedDialogProps = {
  dataAsset: Workflow;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

function UnlockedDialog({
  dataAsset,
  open,
  onClose,
  onSuccess,
}: UnlockedDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onSuccess={() => onSuccess()}
      onClose={() => onClose()}
      title={`Permanently lock Data Asset \"${dataAsset.name}\"?`}
      description="Data assets cannot be unlocked. Are you sure you want to permanently lock this data asset?"
      okButtonCaption="Yes"
      cancelButtonCaption="No"
    />
  );
}

export const DataAssetLockConfirmDialog: React.FC<DataAssetLockConfirmDialogProps> = ({
  dataAsset,
  open,
  onClose,
  onSuccess,
}) => {
  return (
    <UnlockedDialog
      dataAsset={dataAsset}
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};
